export default __webpack_public_path__ + "static/media/features-03-image-01.f5fdf779.jpg";